import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  config: {
    initialColorMode: "dark",
    useSystemColorMode: false,
  },
  fonts: {
    heading: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
    body: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
  },
  styles: {
    global: {
      html: {
        scrollBehavior: "smooth",
        scrollPaddingTop: "80px",
      },
    },
  },
  layerStyles: {
    glassCard: {
      bg: "rgba(255, 255, 255, 0.05)",
      backdropFilter: "blur(10px)",
      borderRadius: "xl",
      border: "1px solid",
      borderColor: "whiteAlpha.200",
    },
  },
});

export default theme;
